module.exports = __webpack_public_path__ + "img/03e6f72ee9dc6262900ea86e21e94284.png";